<script>
import Swal from "sweetalert2";
import RowWrapper from "@/components/wrappers/RowWrapper";
import { SupplierServices } from "@/services/nextshop/supplier.service";
import { OtherService } from "@/services/other.service";

export default {
  page: {
    title: "Thêm mới nhà cung cấp",
  },
  components: {
    RowWrapper,
  },
  data() {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      title: "THÊM MỚI NHÀ CUNG CẤP",
      loading: false,
      inforAccount: JSON.parse(localStorage.getItem("auth.currentUser")),
      items: [
        {
          text: "Nhà cung cấp",
          href: JSON.parse(localStorage.getItem("dataPermission")) && JSON.parse(localStorage.getItem("dataPermission")).includes("NSH_PARTNER_SUP_VIEW") ? "/supplier-list" : "#",
        },
        {
          text: "Thêm mới nhà cung cấp",
          active: true,
        },
      ],
      dropzoneOptions: {
        url: "https://npa-api-gateway.nextshop.dev/s3/image?fileName=1633621539916&folder=nextshop",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
        maxFilesize: 2,
        maxFiles: 1,
        headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true,
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
      },
      dropzoneFiles: [],
      name: {},
      dateDob: {},

      // list address
      listCity: [],
      listDistrict: [],
      listWard: [],

      listGender: [
        { id: "FEMALE", text: "Nam" },
        { id: "MALE", text: "Nữ" },
        { id: "OTHERS", text: "Khác" },
      ],
      listType: [
        { id: true, text: "Cá nhân" },
        { id: false, text: "Doanh nghiệp" },
      ],
      listGroup: [],

      //input
      dataSupplier: {
        city: null,
        district: null,
        ward: null,
        groups: [],
        isPerson: { id: true, text: "Cá nhân" },
        note: null,
      },
      //add group
      dataGroup: {},
      modalNewGroup: false,
      errUpload: "",
    };
  },
  async created() {
    this.getGroup();
    await this.getListCity();
    await this.getListDistrict({ id: this.dataSupplier.city.id });
    await this.getListWard({ id: this.dataSupplier.district.id });
    // this.focusInput();
  },
  methods: {
    // allow input number
    allowNumbersOnly($event) {
      if (!["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes($event.key) && $event.keyCode !== 8) {
        $event.preventDefault();
      }
    },
    async getGroup() {
      try {
        const response = await SupplierServices.getGroupSupplier({
          merchantId: this.inforAccount.merchantId,
          page: 1,
          limit: 100,
        });
        if (response.success) {
          this.listGroup = response.data;
        }
        if (this.dataPermission && this.dataPermission.includes("NSH_PARTNER_GROUP_SUP_CREATE")) {
          this.listGroup.unshift({ id: 0, name: "Thêm mới" });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    onSelect(data) {
      if (data.id == 0) {
        this.dataSupplier.groups[0] = [];
        this.dataGroup = {};
        this.modalNewGroup = true;
      }
    },
    // Get list locations
    async getListCity() {
      const response = await OtherService.getlistCity();
      this.listCity = response.data.map((e) => {
        return {
          id: e.code,
          text: e.name,
        };
      });
      // const OBJ = await this.listCity.filter((e) => {
      //   if (e.id == this.dataSupplier.cityCode) return e;
      // });
      // this.dataSupplier.city = OBJ[0];
    },

    async getListDistrict({ id }) {
      this.listDistrict = [];
      const response = await OtherService.getlistDistrict({
        cityCode: id,
        countryCode: "vn",
      });
      if (response.success) {
        this.listDistrict = response.data.map((e) => {
          return {
            id: e.code,
            text: e.name,
          };
        });
      }
      // const OBJ = this.listDistrict.filter((e) => {
      //   if (e.id == this.dataSupplier.districtCode) return e;
      // });
      // this.dataSupplier.district = OBJ[0];
    },

    async getListWard({ id }) {
      this.listWard = [];
      const response = await OtherService.getlistWard({
        cityCode: this.dataSupplier.city.id,
        countryCode: "vn",
        districtCode: id,
      });
      if (response.success) {
        this.listWard = response.data.map((e) => {
          return {
            id: e.code,
            text: e.name,
          };
        });
      }
      // this.dataSupplier.ward = this.listWard.filter((e) => {
      //   if (e.id == this.dataSupplier.wardCode) return e;
      // });
    },
    // Create Item
    async createItem(validate) {
      validate().then(async (success) => {
        // this.messageError = new Object();
        if (!success || this.errUpload != "") {
          const el = document.querySelector(".is-invalid");
          el.focus();
          return;
        } else {
          this.loading = true;
          const date = this.birthday ? new Date(this.birthday) : null;
          const birthdayUpdate = date ? date.toISOString() : null;
          const params = {
            merchantId: this.inforAccount.merchantId,
            avatarUrl: this.dataSupplier.avatarUrl,
            address: this.dataSupplier.address ? this.dataSupplier.address : null,
            birthday: birthdayUpdate,
            cityCode: this.dataSupplier.city ? this.dataSupplier.city.id : null,
            districtCode: this.dataSupplier.district ? this.dataSupplier.district.id : null,
            wardCode: this.dataSupplier.ward ? this.dataSupplier.ward.id : null,
            isPerson: this.dataSupplier.isPerson ? this.dataSupplier.isPerson.id : null,
            groups: this.dataSupplier.groups.length > 0 ? [this.dataSupplier.groups[0].id] : [],
            name: this.dataSupplier.name,
            phoneNo: this.dataSupplier.phoneNo,
            sex: this.dataSupplier.sex,
            email: this.dataSupplier.email ? this.dataSupplier.email : null,
            note: this.dataSupplier.note ? this.dataSupplier.note : null,
          };
          try {
            const response = await SupplierServices.createrSupplier(params);
            if (response.code === "SUCCESSFUL") {
              this.loading = true;
              this.successmsg(response.data.id);
            } else if (response.code === "PHONE_EXISTED") {
              this.phoneNoExistedMsg(response.data.id);
            }
          } catch (error) {
            this.failedmsg();
            console.log(error);
          } finally {
            this.loading = false;
          }
        }
      });
    },
    // Upload IMG
    async uploadImage(image) {
      try {
        const fd = new FormData();
        fd.append("image", image);
        const data = await OtherService.uploadImage(fd);
        if (data.success) {
          this.errUpload = "";
          this.dataSupplier.avatarUrl = data.data.imageLink;
          this.dropzoneFiles = this.$refs.myVueDropzone.getAcceptedFiles();
        }
      } catch (err) {
        console.log(err);
      }
    },

    // delay time
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async vmounted() {
      await this.sleep(1000);
      if (this.dataSupplier.avatarUrl) {
        const fileLogoStore = {
          name: `logoStore`,
          size: 2000000,
          type: "image/jpg",
          url: this.dataSupplier.avatarUrl,
        };
        this.dropzoneFiles.push(fileLogoStore);
        this.$refs.myVueDropzone.manuallyAddFile(fileLogoStore, this.dataSupplier.avatarUrl);
      }
    },
    // upload & remove & method IMG
    removeThisFile() {
      this.dataSupplier.avatarUrl = "";
      this.errUpload = "";
      this.dropzoneFiles = this.$refs.myVueDropzone.getAcceptedFiles();
    },
    // fix mess erro of item
    failed(file, message) {
      const elements = document.querySelectorAll(".dz-error-message span");
      const lastElement = elements[elements.length - 1];
      lastElement.textContent = message;
      if (file.size > 2000000) {
        lastElement.textContent = "Vượt quá dung lượng tối đa cho phép (2MB).";
        this.errUpload = "Vượt quá dung lượng tối đa cho phép (2MB).";
        Swal.fire({
          title: "Dung lượng ảnh quá lớn",
          text: "Dung lượng tối đa ảnh tải lên là 2MB (.PNG .JPG .JPEG .GIF). Vui lòng chọn ảnh khác.",
          icon: "warning",
          confirmButtonText: "Xác nhận",
        });
      } else {
        lastElement.textContent = "Ảnh không đúng định dạng";
        this.errUpload = "Ảnh không đúng định dạng.";
        Swal.fire({
          title: "Ảnh chọn sai định dạng",
          text: "Ảnh chọn sai định dạng (.PNG, .JPG). Vui lòng chọn ảnh khác.",
          icon: "warning",
          confirmButtonText: "Xác nhận",
        });
      }
    },
    successmsg(id) {
      Swal.fire({
        title: "Thành công",
        text: `Đã tạo mới nhà cung cấp thành công!`,
        icon: "success",
        confirmButtonText: "Xác nhận",
      }).then(() => {
        this.$router.push({ path: `/supplier-list/supplier-detail/${id}` });
      });
    },

    phoneNoExistedMsg(id) {
      Swal.fire({
        title: "Thất bại",
        text: `Số điện thoại bạn vừa nhập trùng với một tài khoản khác. Vui lòng điền lại số điện thoại hoặc cập nhật tài khoản sẵn có.`,
        icon: "error",
        confirmButtonText: "Điền lại số điện thoại",
        cancelButtonText: "Cập nhật KH cũ",
        reverseButtons: true,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.dataSupplier.phoneNo = null;
        } else {
          this.$router.push({ path: `/supplier-list/supplier-edit/${id}` });
        }
      });
    },

    failedmsg() {
      Swal.fire("Thất bại", "Tạo mới thất bại!", "error");
    },
    //Auto forcus
    focusInput() {
      this.$refs.name.$el.focus();
    },
    //Max length
    maxLength(e) {
      return String(e).substring(0, 15);
    },
    // add group
    async saveItem(validate) {
      validate().then(async (success) => {
        if (!success) {
          const el = document.querySelector(".is-invalid");
          el.focus();
          return;
        } else {
          this.loading = true;
          try {
            const params = {
              merchantId: this.inforAccount.merchantId,
              name: this.dataGroup.name,
              description: this.dataGroup.description ? this.dataGroup.description : null,
              defaultGroup: false,
            };
            const response = await SupplierServices.createGroup(params);
            if (response.success) {
              this.modalNewGroup = false;
              this.dataSupplier.groups[0] = response.data;
              Swal.fire("Thành công", "Tạo mới nhóm nhà cung cấp thành công!", "success");
              await this.getGroup();
            }
          } catch (error) {
            console.log(error);
          } finally {
            this.loading = false;
          }
        }
      });
    },
    destroyModal() {
      this.modalNewGroup = false;
    },
  },
};
</script>

<template>
  <div class="custom_theo_design">
    <validation-observer ref="observerPartner" v-slot="{ validate }">
      <div class="layout-wrapper">
        <header id="page-topbar">
          <BaseButton variant="secondary" @click="$router.go(-1)">Quay lại</BaseButton>

          <div class="title">
            <p>Thêm mới nhà cung cấp</p>
          </div>

          <div class="row" v-if="dataPermission && dataPermission.includes('NSH_PARTNER_SUP_CREATE')">
            <el-button type="primary" @click="createItem(validate)">Hoàn tất</el-button>
          </div>
        </header>
      </div>

      <div class="container form_card_custom" style="margin-top: 96px;">
        <div v-if="dataPermission && dataPermission.includes('NSH_PARTNER_SUP_CREATE')">
          <!-- moi -->
          <b-card class="form-card">
            <div class="d-flex justify-content-between align-items-center">
              <div class="form-card_title mb-4">Thông tin cơ bản</div>
            </div>
            <div class="row">
              <div class="sub_title col-2 text-right pt-2">Tên NCC<sup class="text-danger"> * </sup></div>
              <div class="col-4 mb-2">
                <b-form-group label="" label-for="formrow-firstname-input">
                  <validation-provider name="Tên nhà cung cấp" rules="required|lBetween:1,255|CHECK_HTML" v-slot="{ errors, valid }">
                    <b-form-input
                      id="formrow-firstname-input"
                      type="text"
                      placeholder="Nhập tên nhà cung cấp"
                      v-model="dataSupplier.name"
                      :state="errors[0] ? false : valid ? true : null"
                      @keydown.enter.prevent
                    />
                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </div>
              <div class="sub_title col-2 text-right pt-2">Số điện thoại<sup class="text-danger"> * </sup></div>
              <div class="col-4 mb-2">
                <b-form-group label="" label-for="formrow-phone-input">
                  <validation-provider name="Số điện thoại" rules="required|PHONE_NO_3|CHECK_HTML|lBetween:1,15" v-slot="{ errors, valid }">
                    <b-form-input
                      id="formrow-phone-input"
                      type="text"
                      placeholder="Nhập số điện thoại"
                      v-model.trim="dataSupplier.phoneNo"
                      @keydown.enter.prevent
                      @keydown="allowNumbersOnly"
                      :state="errors[0] ? false : valid && dataSupplier.phoneNo != null ? true : null"
                    />
                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="sub_title col-2 text-right pt-2">Nhóm</div>
              <div class="col-4">
                <b-form-group id="input-group-1" label="" label-for="">
                  <multiselect
                    v-model="dataSupplier.groups[0]"
                    :options="listGroup"
                    deselectLabel=""
                    selectLabel=""
                    selectedLabel=""
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Chọn nhóm"
                    label="name"
                    track-by="id"
                    @input="onSelect(dataSupplier.groups[0])"
                  >
                    <template slot="noOptions"> Chưa có dữ liệu </template>
                  </multiselect>
                </b-form-group>
              </div>
              <div class="sub_title col-2 text-right pt-2">Phân loại</div>
              <div class="col-4">
                <b-form-group id="input-group-1" label="" label-for="">
                  <multiselect
                    v-model="dataSupplier.isPerson"
                    track-by="id"
                    label="text"
                    deselectLabel=""
                    selectLabel=""
                    selectedLabel=""
                    placeholder="Chọn phân loại"
                    :options="listType"
                    :searchable="false"
                    :allow-empty="false"
                  >
                    <template slot="noOptions"> Chưa có dữ liệu </template>
                  </multiselect>
                </b-form-group>
              </div>
            </div>
          </b-card>

          <b-card class="form-card">
            <div class="d-flex justify-content-between align-items-center">
              <div class="form-card_title mb-4">Thông tin bổ sung</div>
            </div>
            <div class="row">
              <div class="sub_title col-2 text-right pt-2">Email</div>
              <div class="col-4 mb-2">
                <b-form-group label="" label-for="formrow-email-input">
                  <validation-provider name="Email" rules="EMAIL|CHECK_HTML|lBetween:6,255" v-slot="{ errors, valid }">
                    <b-form-input
                      id="formrow-email-input"
                      type="text"
                      placeholder="Nhập địa chỉ email"
                      v-model.trim="dataSupplier.email"
                      trim
                      :state="errors[0] ? false : valid && dataSupplier.email != null && dataSupplier.email != '' ? true : null"
                    />
                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </div>
              <div class="sub_title col-2 text-right pt-2">Tỉnh/Thành phố</div>
              <div class="col-4 mb-2">
                <b-form-group id="input-group-1" label="" label-for="formrow-inputField">
                  <multiselect
                    v-model="dataSupplier.city"
                    track-by="id"
                    label="text"
                    deselectLabel=""
                    selectLabel=""
                    selectedLabel=""
                    placeholder="Chọn Tỉnh/Thành phố"
                    :options="listCity"
                    :allow-empty="false"
                    @select="getListDistrict($event)"
                  >
                    <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
                    <template slot="noOptions"> Chưa có dữ liệu </template>
                    <template slot="noResult">Không tìm thấy dữ liệu </template>
                  </multiselect>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="sub_title col-2 text-right pt-2">Quận/ Huyện</div>
              <div class="col-4 mb-2">
                <b-form-group id="input-group-1" label="" label-for="formrow-inputField">
                  <multiselect
                    v-model="dataSupplier.district"
                    track-by="id"
                    label="text"
                    deselectLabel=""
                    selectLabel=""
                    selectedLabel=""
                    placeholder="Chọn Quận/Huyện"
                    :options="listDistrict"
                    :allow-empty="false"
                    @select="getListWard($event)"
                  >
                    <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
                    <template slot="noOptions"> Chưa có dữ liệu </template>
                    <template slot="noResult"> Không tìm thấy dữ liệu </template>
                  </multiselect>
                </b-form-group>
              </div>
              <div class="sub_title col-2 text-right pt-2">Phường/ Xã</div>
              <div class="col-4 mb-2">
                <b-form-group id="input-group-1" label="" label-for="formrow-inputField">
                  <multiselect
                    v-model="dataSupplier.ward"
                    track-by="id"
                    label="text"
                    deselectLabel=""
                    selectLabel=""
                    selectedLabel=""
                    placeholder="Chọn Phường/Xã"
                    :options="listWard"
                    :allow-empty="false"
                  >
                    <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
                    <template slot="noOptions"> Chưa có dữ liệu </template>
                    <template slot="noResult">Không tìm thấy dữ liệu</template>
                  </multiselect>
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="sub_title col-2 text-right pt-2">Địa chỉ cụ thể</div>
              <div class="col-10 mb-2">
                <b-form-group label="" label-for="formrow-address-input">
                  <validation-provider name="Địa chỉ cụ thể" rules="lBetween:3,255|CHECK_HTML" v-slot="{ errors, valid }">
                    <b-form-input
                      v-model.trim="dataSupplier.address"
                      id="formrow-address-input"
                      class="form-control"
                      type="text"
                      placeholder="Nhập địa chỉ"
                      :state="errors[0] ? false : valid && dataSupplier.address != null && dataSupplier.address != '' ? true : null"
                    />

                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </div>
              <div class="sub_title col-2 text-right pt-2">Ghi chú</div>
              <div class="col-10">
                <b-form-group label="" label-for="formrow-address-input">
                  <validation-provider name="Ghi chú" rules="lBetween:3,255|CHECK_HTML" v-slot="{ errors, valid }">
                    <b-form-textarea
                      v-model.trim="dataSupplier.note"
                      id="formrow-address-input"
                      class="form-control"
                      name="textarea"
                      rows="3"
                      placeholder="Ghi chú"
                      :state="errors[0] ? false : valid && dataSupplier.note != null && dataSupplier.note != '' ? true : null"
                    />

                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </div>
            </div>
          </b-card>

          <!-- cu -->
          <div>
            <b-modal v-model="modalNewGroup" centered hide-footer no-close-on-backdrop>
              <template #modal-header>
                <h4 class="title-modal-custom mb-0">Thêm mới nhóm nhà cung cấp</h4>
                <button type="button" aria-label="Close" class="close" @click="destroyModal">
                  <i class="el-icon-close"></i>
                </button>
              </template>
              <!-- <button @click="destroyModal()" type="button" aria-label="Close" class="close close-ext">
                ×
              </button>
              <div class="text-title-modal mb-3">Thêm mới nhóm nhà cung cấp</div> -->
              <validation-observer ref="observerPartner" v-slot="{ validate }">
                <RowWrapper>
                  <template #center>
                    <RowWrapper>
                      <template #center>
                        <b-form-group label="" label-for="formrow-groupname-input">
                          <validation-provider name="Tên nhóm" rules="required|lBetween:1,255|CHECK_HTML" v-slot="{ errors, valid }">
                            <label>Tên nhóm<sup class="text-danger"> * </sup></label>

                            <b-form-input
                              id="formrow-groupname-input"
                              type="text"
                              placeholder="Nhập tên nhóm"
                              v-model="dataGroup.name"
                              :state="errors[0] ? false : valid ? true : null"
                              @keydown.enter.prevent
                            />

                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                          </validation-provider>
                        </b-form-group>
                      </template>
                    </RowWrapper>

                    <RowWrapper>
                      <template #center>
                        <b-form-group label="" label-for="formrow-description-input">
                          <validation-provider name="Mô tả" rules="lBetween:1,500|CHECK_HTML" v-slot="{ errors, valid }">
                            <label>Mô tả</label>

                            <b-form-textarea
                              v-model.trim="dataGroup.description"
                              id="formrow-description-input"
                              class="form-control"
                              name="textarea"
                              rows="3"
                              placeholder="Nhập mô tả"
                              :state="errors[0] ? false : valid && dataGroup.description != null && dataGroup.description != '' ? true : null"
                            />

                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                          </validation-provider>
                        </b-form-group>
                      </template>
                    </RowWrapper>
                  </template>
                </RowWrapper>
                <div class="row">
                  <div class="d-flex justify-content-end m-2 w-100">
                    <button class="btn btn-primary" @click.prevent="saveItem(validate)">
                      Hoàn tất
                    </button>
                  </div>
                </div>
              </validation-observer>
            </b-modal>
          </div>
          <div class="box-loading" v-if="loading">
            <div class="loading">
              <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
            </div>
          </div>
        </div>
        <NotPermission v-else></NotPermission>
      </div>
    </validation-observer>
  </div>
</template>
